// @ts-nocheck
/* eslint-disable */
import Scene from "~/scene";

Mapy.LayerWinter = function(id, options = {}) {
	Mapy.LayerCanvasGeom.call(this, id || "layer-winter", options);
	this._lastGeometry = null;
}

Mapy.LayerWinter.prototype = Object.create(Object.assign({}, SMap.Layer.prototype, Mapy.LayerTraffic.prototype, Mapy.LayerCanvasGeom.prototype));

Mapy.LayerWinter.prototype.enable = function() {
	const container = document.getElementById("map");

	if (container) {
		container.addEventListener("mousemove", this);
		container.addEventListener("click", this);
	}

	return Mapy.LayerCanvasGeom.prototype.enable.call(this);
};

Mapy.LayerWinter.prototype.disable = function() {
	const container = document.getElementById("map");

	if (container) {
		container.removeEventListener("mousemove", this);
		container.removeEventListener("click", this);
	}

	return Mapy.LayerCanvasGeom.prototype.disable.call(this);
};

Mapy.LayerWinter.prototype._build = function() {
	this._canvas = document.createElement("canvas");
	this._canvas.style.position = "absolute";
	this._ctx = this._canvas.getContext("2d");

	this._canvasColor = document.createElement("canvas");
	this._canvasColor.style.position = "absolute";
	this._ctxColor = this._canvasColor.getContext("2d", { alpha: true });
	//this._ctxColor.imageSmoothingEnabled = false;

	this._dom.container[SMap.LAYER_TILE] = this._canvas;
};

Mapy.LayerWinter.prototype.handleEvent = function(e) {
	if (e.type == "mousemove") {
		const geometry = this.geometryOnCursor(e.clientX, e.clientY);

		// byla stara a neni stejna jako nova
		if (this._lastGeometry && (!geometry || this._lastGeometry.id !== geometry.id || this._lastGeometry.source !== geometry.source)) {
			this._canvas.style.removeProperty("cursor");
			Scene.makeEvent("geometry-canvas-mouseout", { event: e }, this._lastGeometry);
		}
		// je nova a neni stejna jako stara
		if (geometry && (!this._lastGeometry || this._lastGeometry.id !== geometry.id || this._lastGeometry.source !== geometry.source)) {
			this._canvas.style.cursor = "pointer";
			Scene.makeEvent("geometry-canvas-mouseover", { event: e }, geometry);
		}

		// nakonec novou nebo null ulozime jako posledni stav
		this._lastGeometry = geometry;
	} else if (e.type == "click") {
		const geometry = this.geometryOnCursor(e.clientX, e.clientY);
		if (geometry && geometry.source) {
			Scene.makeEvent("geometry-canvas-click", { event: e }, geometry);
		}
	}
}
